/*
 * @LastEditors: Yx
 * @LastEditTime: 2022-07-25 15:47:57
 * @Description:
 * @Author: Yx
 * @Date: 2022-07-15 17:04:50
 * @FilePath: \szjzsoft-framework\src\plugins\element.js
 */
import Vue from "vue";

import {
  Row,
  Col,
  Pagination,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Carousel,
  CarouselItem,
  Breadcrumb,
  Form,
  FormItem,
  Input,
  BreadcrumbItem,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  ButtonGroup,
  Message,
  Notification,
  Loading,
} from "element-ui";

Vue.use(Row);
Vue.use(Col);
Vue.use(Dropdown);
Vue.use(Pagination);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
